import '../../app.es6';
import angular from 'angular';

class AdminSchoolListController {
  /* @ngInject */
  constructor (
    $rootScope, $scope, $sessionStorage, $location,
    commonApiFactory, commonFactory, Const, Page
  ) {
    this.Const = Const;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
    this.$location = $location;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    this.commonFactory.overlayHidden();
    this.commonFactory.deleteErrorFlg();

    // School AdminもCompany AdminのAPIを叩けてしまうため、
    // 画面遷移を阻止
    if (localStorage.getItem(this.Const.LSAPP_ROLE) !== this.Const.LSAPP_ROLE_C_ADMIN) {
      this.$location.path('/admin');
    }

    // APIから取得したスクールが存在している場合：true
    // APIから取得したスクールが存在していない場合：false
    this.existenceFlg = true;

    this.getCompaniesMeSchools();

    Page.setTitle(this.Const.TITLE.topForCompanyAdmin);

    AdminSchoolListController.$inject = ['$rootScope', '$scope',
                                        '$sessionStorage', '$location',
                                        'commonApiFactory', 'commonFactory',
                                        'Const', 'Page'];
  }

  getCompaniesMeSchools () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }
    this.commonApiFactory.getAdminCompaniesMeSchools()
    .then((result) => {
      this.schoolList = [];
      if (result.length === 0) {
        this.existenceFlg = false;
        this.commonFactory.overlayHidden();
        this.$scope.$apply();
        return;
      }
      result.forEach((school) => {
        let schoolObj = {
          id: school.id,
          name: school.name
        };
        this.schoolList.push(schoolObj);
      });
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    })

    .catch((error) => {
      this.existenceFlg = false;
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
      console.log('error : ', error);
    });
  }

  toSchoolTop (school) {
    this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID] = school.id;
    this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME] = school.name;
    this.$location.path('/admin');
  }

  generatePassword (school) {
    this.$rootScope.targetId = school.id;
    this.$rootScope.password = this.commonFactory.createImterimPassword();
  }
}

angular.module('myApp').controller('AdminSchoolListController', AdminSchoolListController);



// WEBPACK FOOTER //
// ./app/components/admin-school-list/admin-school-list-controller.es6